// Copyright (c) 2022 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { TILES_VIEW_TYPE } from "./index"
import { ofType } from "redux-observable"
import { TilesViewType } from "../action-pane/tiles/tiles"

export type StorageReader = () => Observable<TilesViewType>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(TILES_VIEW_TYPE)
    if (data !== null) {
      // convert to number for matching index from TilesViewType enum
      return of(Number(data))
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadTilesViewType = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      ofType(Actions.loadTilesViewTypeFromStorage),
      mergeMap(_ => load().pipe(
        map((tilesViewType: TilesViewType) => {
          if (TilesViewType[tilesViewType] === undefined) {
            // Overwrite stale TilesViewType in localStorage to initial value
            return Slice.setTilesViewType(Slice.initialState.tilesViewType)
          }
          return Slice.setTilesViewType(tilesViewType)
        }),
        catchError(_ => of(Actions.loadTilesViewTypeFromStorageFailed())),
      )),
    )

export default loadTilesViewType(load)
